import { OptionJobWithNameAndLocation } from 'types/jobs';

const handleSearchJobOptionsWithNameAndLocation = (
  input: string,
  option?: OptionJobWithNameAndLocation
) => {
  const location = option?.location;

  return Boolean(
    option?.name?.toLowerCase().includes(input.toLowerCase()) ||
      location?.city?.toLowerCase()?.includes(input.toLowerCase())
  );
};

export default handleSearchJobOptionsWithNameAndLocation;
